import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { Slider } from '@/components/ui/slider'
import { Switch } from '@/components/ui/switch'
import type { Question } from '@/types/form'

interface QuestionSettingsProps {
  question: Question
  onChange: (patch: Partial<Question['settings']>) => void
}

const types = ['PDF', '圖片', '影片', '音訊', 'Word', 'Excel', '壓縮檔']

export function FileUploadSettings({ question, onChange }: QuestionSettingsProps) {
  const selected = question.settings.allowedTypes ?? []

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <Label>允許的檔案類型</Label>
        <div className="grid grid-cols-2 gap-2">
          {types.map((type) => (
            <label
              key={type}
              className="flex items-center gap-2 rounded-md border border-slate-200 p-2 text-sm"
            >
              <input
                type="checkbox"
                checked={selected.includes(type)}
                onChange={(event) =>
                  onChange({
                    allowedTypes: event.target.checked
                      ? [...selected, type]
                      : selected.filter((item) => item !== type),
                  })
                }
              />
              {type}
            </label>
          ))}
        </div>
      </div>
      <div className="flex flex-col gap-2">
        <Label>最大檔案大小：{question.settings.maxFileSizeMb ?? 10} MB</Label>
        <Slider
          value={[Number(question.settings.maxFileSizeMb ?? 10)]}
          min={1}
          max={100}
          step={1}
          onValueChange={([maxFileSizeMb]) => onChange({ maxFileSizeMb })}
        />
      </div>
      <div className="flex items-center justify-between gap-3 text-sm">
        <span>允許多檔上傳</span>
        <Switch
          aria-label="允許多檔上傳"
          checked={Boolean(question.settings.allowMultiple)}
          onCheckedChange={(allowMultiple) => onChange({ allowMultiple })}
        />
      </div>
      {question.settings.allowMultiple && (
        <div className="flex flex-col gap-2">
          <Label>最多上傳檔數</Label>
          <Input
            type="number"
            value={question.settings.maxFiles ?? 3}
            onChange={(event) => onChange({ maxFiles: Number(event.target.value) })}
          />
        </div>
      )}
    </div>
  )
}
